import { state } from '@/shared/components/player/store';
import { replaceEmbeddedRoute } from '@/shared/utils';

export default {
  computed: {
    nextRelatedProduct() {
      return state.nextRelatedProduct || {};
    },
  },
  methods: {
    playNextRelatedProduct() {
      if (!state.isEmbedded) {
        return;
      }

      const { slug, id, type, articleId, articleType, articleSlug } = this.nextRelatedProduct;

      this.$stats.playNext(state.product);
      state.previousRelatedProducts.push(state.product);
      state.nextRelatedProducts.shift();

      replaceEmbeddedRoute({ slug, id, type, articleId, articleType, articleSlug, component: this });
    },
  },
};
